// frontend/src/pages/WaiverPage.js
import React from 'react';
import { useApi } from '../hooks/useApi';
import API from '../services/api';

const WaiverPage = () => {
  const { data: waiver, loading, error } = useApi(() => API.content.getWaiverContent());

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center pt-24">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-emerald-500"></div>
      </div>
    );
  }

  if (error || !waiver) {
    return (
      <div className="min-h-screen bg-gray-900 pt-24 px-4">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h1 className="text-4xl font-bold mb-4">Waiver Not Available</h1>
          <p className="text-gray-400">Please contact us for more information.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 pt-24 px-4 pb-12">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-white mb-4">
            {waiver.title}
          </h1>
          <p className="text-gray-400">
            Version: {waiver.version} | Effective: {new Date(waiver.effective_date).toLocaleDateString()}
          </p>
        </div>

        {/* Waiver Content */}
        <div className="bg-white rounded-2xl p-8 shadow-2xl">
          <div 
            className="waiver-content prose prose-lg max-w-none"
            dangerouslySetInnerHTML={{ __html: waiver.content }}
          />
        </div>

        {/* Footer */}
        <div className="mt-8 text-center">
          <p className="text-gray-400 text-sm">
            Questions? Contact us at{' '}
            <a href="mailto:info@layouadventures.com" className="text-emerald-400 hover:text-emerald-300">
              info@layouadventures.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default WaiverPage;